// TODO: Revert to target="_blank"
const replacement = (charCode) => {
    return `$1<a href="${process.env.VUE_APP_BASE_URL}search?q=%${charCode}$3" target="_self">$2</a>`;
};

const atSign = 40;
const dollarSign = 24;
const numberSign = 23;

class KeywordFormatter {
    format(message) {
        return message.replace(/(\W)((?:#)([a-z]+[\w-]*))(?=\W)/gi, replacement(numberSign));
    }
}

class TickerFormatter {
    format(message) {
        return message.replace(/(\W)((?:\$)([a-z]+[a-z0-9]*))(?=\W)/gi, replacement(dollarSign));
    }
}

class UserNameFormatter {
    format(message) {
        return message.replace(/(\W)((?:@)([\w-]+))(?=\W)/gi, replacement(atSign));
    }
}

const formatPost = (message) => {
    let formatted = message.toString();

    let formatters = [
        new KeywordFormatter(),
        new TickerFormatter(),
        new UserNameFormatter()
    ];

    formatters.forEach(formatter => {
        formatted = formatter.format(formatted);
    });

    return formatted;
};

export default formatPost
